module.exports = __webpack_public_path__ + "static/media/visaLight.20290974.svg";